import { render } from "./mega-nav.vue?vue&type=template&id=5791a7ca"
import script from "./mega-nav.vue?vue&type=script&lang=js"
export * from "./mega-nav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__